/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_historyCarousel", {
        options: {
            slickOptions: {
                arrows: true,
                autoplay: false,
                autoplaySpeed: 4000,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                rows: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet, // tablet view
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
                appendArrows: jQuery(".s-history__carousel__toolbar .b-slick-arrows"),
            },
        },

        _create: function () {
            this.wrap = this.element;

            $(".s-history__items", this.wrap).each((indx, el) => {
                $(el)
                    .on("init", (slick) => {
                        var dots = $(".slick-dots", $(slick.target));
                        api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed / 1000);
                    })
                    .slick(this.options.slickOptions)
                    .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                        var dots = $(".slick-dots", $(event.target));
                        api.fn.slickDotsFilled(dots, nextSlide);
                    });
            });
        },
    });
})(jQuery);
